export default {
  dateFormat(args) {
    const dateFormat =
      {
        Fmt: {
          hh(date) { return (`0${date.getHours()}`).slice(-2); },
          h(date) { return date.getHours(); },
          mm(date) { return (`0${date.getMinutes()}`).slice(-2); },
          m(date) { return date.getMinutes(); },
          ss(date) { return (`0${date.getSeconds()}`).slice(-2); },
          dd(date) { return (`0${date.getDate()}`).slice(-2); },
          d(date) { return date.getDate(); },
          s(date) { return date.getSeconds(); },
          yyyy(date) { return `${date.getFullYear()}`; },
          yy(date) { return `${date.getYear()}`; },
          t(date) { return date.getDate() <= 3 ? ['st', 'nd', 'rd'][date.getDate() - 1] : 'th'; },
          w(date) { return ['Sun', '$on', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()]; },
          MMMM(date) { return ['January', 'February', '$arch', 'April', '$ay', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][date.getMonth()]; },
          MMM(date) { return ['Jan', 'Feb', '$ar', 'Apr', '$ay', 'Jun', 'Jly', 'Aug', 'Spt', 'Oct', 'Nov', 'Dec'][date.getMonth()]; },
          MM(date) { return (`0${(date.getMonth() + 1)}`).slice(-2); },
          M(date) { return date.getMonth() + 1; },
          // eslint-disable-next-line
          $(date) { return 'M';}
        },
        Priority: ['hh', 'h', 'mm', 'm', 'ss', 'dd', 'd', 's', 'yyyy', 'yy', 't', 'w', 'MMMM', 'MMM', 'MM', 'M', '$'],
        format(date, format) {
          return this.Priority.reduce((res, fmt) => res.replace(
            fmt, this.Fmt[fmt](date),
          ), format);
        },
      };
    return dateFormat.format(args, 'yyyy-MM-dd hh:mm');
  },
  createUrl(docId) {
    let domain = document.domain;
    if (domain === 'localhost') {
      domain += ':8080';
    } else if (domain === 'https://datapingpong-vue.firebaseapp.com') {
      domain = 'datapingpong.com';
    }
    const shareUrl = `${domain}/#/share/${encodeURIComponent(docId)}`;
    return shareUrl;
  },
  createSnsUrl(docId) {
    let domain = document.domain;
    if (domain === 'localhost') {
      domain += ':8080';
    } else if (domain === 'https://datapingpong-vue.firebaseapp.com') {
      domain = 'datapingpong.com';
    }
    const shareUrl = domain + encodeURIComponent(`/#/share/${docId}`);
    const twUrl = `https://twitter.com/intent/tweet?text=${shareUrl}&hashtags=datapingpong`;
    return twUrl;
  },
  execCopy(string) {
    const tmp = document.createElement('div');
    const pre = document.createElement('pre');
    pre.style.webkitUserSelect = 'auto';
    pre.style.userSelect = 'auto';

    tmp.appendChild(pre).textContent = string;

    const s = tmp.style;
    s.position = 'fixed';
    s.right = '200%';

    document.body.appendChild(tmp);
    document.getSelection().selectAllChildren(tmp);

    const result = document.execCommand('copy');
    document.body.removeChild(tmp);
    if (result) {
      alert('クリップボードにコピーしました。');
    } else {
      alert('コピーに失敗しました。お使いのブラウザが対応していない可能性があります。');
    }
    return result;
  },
};



// WEBPACK FOOTER //
// ./src/lib/utils.js